import { useMutation, useQueryClient } from '@gogame/query';

import { saveFavorites } from '../../source/favorites';
import { favoriteFiltersQuery } from '../queryKeyFactory';

export const useUpdateFavoriteFilters = ({ screen }) => {
  const queryClient = useQueryClient();

  const favoriteFiltersScreenQuery = favoriteFiltersQuery.query(screen);
  const queryKey = favoriteFiltersScreenQuery.all();
  const mutations = favoriteFiltersScreenQuery.mutations();
  const update = mutations.update();

  const updateMutation = useMutation(
    update(),
    (params) => saveFavorites({ screen, ...params }),
    {
      refreshOptions: {
        queryKey,
      },
      onMutate: async ({ favorites }) => {
        await queryClient.cancelQueries(queryKey);

        const previousValue = queryClient.getQueryData(queryKey);

        queryClient.setQueryData(queryKey, favorites);

        return previousValue;
      },
      onError: (_, __, previousValue) =>
        queryClient.setQueryData(queryKey, previousValue),
    }
  );
  return [updateMutation.mutateAsync, updateMutation];
};
